export default __webpack_public_path__ + "static/media/GreenEnterpriseInternships2.11260fb4.png";